import React from 'react';
import { ActivationAlreadyActivated } from '../Presentation';

export const ActivationAlreadyActivatedContainer: React.FC = () => {
  return <ActivationAlreadyActivated />;
};
